import { displayPhoneNumber } from 'common/utils';
import _ from 'lodash';
import React from 'react';
import { Grid } from 'semantic-ui-react';

const UserContactInformation = ({ user }) => {

    const prioritizePhoneList = () => {
        var order = ['W', 'M', 'H', 'O', 'X'];
        if (!_.isEmpty(user.phoneNumbers)) {
            for (var i = 0; i < order.length; i++) {
                var phone = _.find(user.phoneNumbers, { phoneNumberType: order[i] });
                if (phone) {
                    return (
                        displayPhoneNumber(phone.areaCd, phone.phoneNumber) +
                        (phone.phoneExt !== '' ? ' ext. ' + phone.phoneExt : '')
                    );
                }
            }
        }
    };

    return (
        <div className="user-details">
            <Grid celled>
                <Grid.Row>
                    <Grid.Column width={5}>
                        <strong>
                            {user.firstName} {user.lastName}
                        </strong>
                    </Grid.Column>
                    <Grid.Column width={7}>
                        <small>
                            <strong>Email:</strong>
                        </small>{' '}
                        <br />
                        <span className="wrapped-span">{user.emailAdr}</span>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <small>
                            <strong>Phone:</strong>
                        </small>{' '}
                        <br />
                        {prioritizePhoneList()}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    )
}

export default UserContactInformation;